import { render, staticRenderFns } from "./CkeditorComponent.vue?vue&type=template&id=2f5d02a2&scoped=true&"
import script from "./CkeditorComponent.vue?vue&type=script&lang=js&"
export * from "./CkeditorComponent.vue?vue&type=script&lang=js&"
import style0 from "./CkeditorComponent.vue?vue&type=style&index=0&id=2f5d02a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5d02a2",
  null
  
)

export default component.exports